// extracted by mini-css-extract-plugin
export default {"textBox":"index_textBox__gcUm2","label":"index_label__QkX5f","description":"index_description__KQBsx"};